import type { DeepPartial } from '@luna/utils-ts';

import type { SavingsConfig } from '../ProductsConfig';
import { settingsDetails } from './settings-details-config/HU';

export const savings: DeepPartial<SavingsConfig> = {
    associatedCards: {
        enabled: false,
    },
    statements: {
        showMultiDownloadCard: true,
    },
    cancellation: {
        options: {
            showCancellationTypeSelect: true,
        },
        signing: {
            showCancellationTitle: true,
        },
        focusPage: {
            errorPageTitle: 'account.scheduledTermDepositCancelation.stripeErrorTitle',
            successPageTitle: 'account.scheduledTermDepositCancelation.stripeClosedTitle',
            signingPageTitle: 'account.scheduledTermDepositCancelation.stripeSigningTitle',
            optionsPageTitle: 'account.scheduledTermDepositCancelation.stripeTitle',
        },
        successMessage: 'account.details.services.cancellation.signing.text',
    },
    useDisposableInsteadOfBalance: true,
    useDisposableAndBalanceInOverviewCard: true,
    settingsDetails,
    newTransfer: {
        sideMenuLabel: 'savings.main.newWithdrawal',
    },
    layout: {
        productInfo: {
            showDisposableAndBalanceAmounts: true,
        },
    },
};
